import { BodyProps } from 'constants/MultipleAcorddions';
import React, { memo, useCallback, useContext, useEffect, useRef } from 'react';
import { ALICtx } from 'pages';
import { Flex, Box, Stack } from '@chakra-ui/react';
import { Button, Unform, AddObservation, CheckboxComp } from 'components';
import { FormHandles, SubmitHandler } from '@unform/core';
import ALI from 'models/Forms/ALI';
import { checkPermission } from 'utils/authentication';

interface IProps extends BodyProps {}
const Item: React.FC<IProps> = ({ functionCallback, index, submit, completed }) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const ctx = useContext(ALICtx);
  const formRef = useRef<FormHandles>(null);
  const [boxes, setBoxes] = React.useState<string[]>(
    ctx.data.activityDataSources
      ?.replace(/^no$/gi, '')
      .replace(/,\s/g, '{{v}}')
      .split(',')
      .map(i => i.replaceAll('{{v}}', ', ')) || [],
  );

  useEffect(() => {
    ctx.handlePayload(prevState => ({
      ...prevState,
      activityDataSources: boxes.filter(i => !!i).toString() || 'no',
    }));

    if (boxes.length === 0 || boxes.includes('no')) {
      ctx.handlePayload(prevState => ({
        ...prevState,
        activities: 'o projeto não trata dados pessoais sensíveis',
      }));
    } else {
      ctx.handlePayload(prevState => ({
        ...prevState,
        activities: 'o projeto trata dados pessoais sensíveis',
      }));
    }
  }, [boxes]);

  function boxClicked(box: string) {
    if (boxes.includes(box)) {
      if (boxes.length === 1) {
        setBoxes([]);
      }
      setBoxes(bx => bx.filter(b => b !== box));
    } else {
      setBoxes(bx => [...bx, box]);
    }
  }

  const handleSubmit = useCallback<SubmitHandler<ALI>>(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async data => {
      setLoading(true);
      if (submit) {
        const resp = await submit();
        if (resp) {
          functionCallback(index + 1);
          setLoading(false);
        }
      } else {
        functionCallback(index + 1);
        setLoading(false);
      }
      setTimeout(() => {
        functionCallback(index + 1);
        setLoading(false);
      }, 1500);
    },
    [functionCallback, submit],
  );

  return (
    <Flex marginTop="1rem" width="100%" direction="column">
      <Box>
        <b>A atividade envolve algum dos seguintes tipos de dados?</b>
        <br />
        <Box fontSize="13px" fontStyle="italic">
          Selecione caso sim
        </Box>
      </Box>
      <Unform formRef={formRef} onSubmit={handleSubmit} initialData={ctx.data}>
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            <Flex mb="22px" mt="23px">
              <Flex flexDirection="column" padding="10px" maxWidth="50%">
                <CheckboxComp
                  // {...cProps}
                  onChange={() => boxClicked('Origem racial ou étnica')}
                  isChecked={boxes.includes('Origem racial ou étnica')}
                >
                  Origem racial ou étnica
                </CheckboxComp>
                <CheckboxComp
                  // {...cProps}
                  onChange={() => boxClicked('Opinião política')}
                  isChecked={boxes.includes('Opinião política')}
                >
                  Opinião política
                </CheckboxComp>
                <CheckboxComp
                  // {...cProps}
                  onChange={() => boxClicked('Dado referentes à saúde')}
                  isChecked={boxes.includes('Dado referentes à saúde')}
                >
                  Dado referentes à saúde
                </CheckboxComp>
                <CheckboxComp
                  // {...cProps}
                  onChange={() => boxClicked('Dado referentes à vida sexual')}
                  isChecked={boxes.includes('Dado referentes à vida sexual')}
                >
                  Dado referentes à vida sexual
                </CheckboxComp>
              </Flex>

              <Flex flexDirection="column" padding="10px" maxWidth="100%">
                <CheckboxComp
                  // {...cProps}
                  onChange={() => boxClicked('Convicção religiosa')}
                  isChecked={boxes.includes('Convicção religiosa')}
                >
                  Convicção religiosa
                </CheckboxComp>
                <CheckboxComp
                  // {...cProps}
                  onChange={() => boxClicked('Filiação a sindicato')}
                  isChecked={boxes.includes('Filiação a sindicato')}
                >
                  Filiação a sindicato
                </CheckboxComp>
                <CheckboxComp
                  // {...cProps}
                  onChange={() =>
                    boxClicked(
                      'Filiação à organização de caráter religioso, filosófico ou político',
                    )
                  }
                  isChecked={boxes.includes(
                    'Filiação à organização de caráter religioso, filosófico ou político',
                  )}
                >
                  Filiação à organização de caráter religioso, filosófico ou político
                </CheckboxComp>
                <CheckboxComp
                  // {...cProps}
                  onChange={() =>
                    boxClicked('Dado genético ou biométrico (DNA, biometria facial, digital, etc.)')
                  }
                  isChecked={boxes.includes(
                    'Dado genético ou biométrico (DNA, biometria facial, digital, etc.)',
                  )}
                >
                  Dado genético ou biométrico (DNA, biometria facial, digital, etc.)
                </CheckboxComp>
              </Flex>
            </Flex>
            <Box mb="24px">
              <Box mt="8px">
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder={'Observações sobre o tratamento de dados (opcional)'}
                  obsValue={
                    ctx.data.jsonCustomObsObj ? ctx.data.jsonCustomObsObj.activityDataSources : ''
                  }
                  onChangeEvent={e =>
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      jsonCustomObsObj: {
                        ...prevState.jsonCustomObsObj,
                        activityDataSources: e.target.value,
                      },
                    }))
                  }
                />
              </Box>
            </Box>
            {!ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
            {ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        ) : (
          <>
            <Flex mb="22px" mt="23px">
              <Flex flexDirection="column" padding="10px" maxWidth="50%">
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Origem racial ou étnica')}
                  isChecked={boxes.includes('Origem racial ou étnica')}
                >
                  Origem racial ou étnica
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Opinião política')}
                  isChecked={boxes.includes('Opinião política')}
                >
                  Opinião política
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Dado referentes à saúde')}
                  isChecked={boxes.includes('Dado referentes à saúde')}
                >
                  Dado referentes à saúde
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Dado referentes à vida sexual')}
                  isChecked={boxes.includes('Dado referentes à vida sexual')}
                >
                  Dado referentes à vida sexual
                </CheckboxComp>
              </Flex>

              <Flex flexDirection="column" padding="10px" maxWidth="100%">
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Convicção religiosa')}
                  isChecked={boxes.includes('Convicção religiosa')}
                >
                  Convicção religiosa
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Filiação a sindicato')}
                  isChecked={boxes.includes('Filiação a sindicato')}
                >
                  Filiação a sindicato
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() =>
                    boxClicked(
                      'Filiação à organização de caráter religioso, filosófico ou político',
                    )
                  }
                  isChecked={boxes.includes(
                    'Filiação à organização de caráter religioso, filosófico ou político',
                  )}
                >
                  Filiação à organização de caráter religioso, filosófico ou político
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() =>
                    boxClicked('Dado genético ou biométrico (DNA, biometria facial, digital, etc.)')
                  }
                  isChecked={boxes.includes(
                    'Dado genético ou biométrico (DNA, biometria facial, digital, etc.)',
                  )}
                >
                  Dado genético ou biométrico (DNA, biometria facial, digital, etc.))
                </CheckboxComp>
              </Flex>
            </Flex>
            <Box mb="24px">
              <Box mt="8px">
                <AddObservation
                  isDetail={completed}
                  placeholder={'Observações sobre o tratamento de dados (opcional)'}
                  obsValue={
                    ctx.data.jsonCustomObsObj ? ctx.data.jsonCustomObsObj.activityDataSources : ''
                  }
                  onChangeEvent={e =>
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      jsonCustomObsObj: {
                        ...prevState.jsonCustomObsObj,
                        activityDataSources: e.target.value,
                      },
                    }))
                  }
                />
              </Box>
            </Box>
            {!completed && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        )}
      </Unform>
    </Flex>
  );
};

export const SensitiveData = memo(Item);
